__turbopack_context__.v({
  "cell": "_4xZM7q_cell",
  "cellUs": "_4xZM7q_cellUs",
  "colHead": "_4xZM7q_colHead",
  "colHeadUs": "_4xZM7q_colHeadUs",
  "headRow": "_4xZM7q_headRow",
  "header": "_4xZM7q_header",
  "label": "_4xZM7q_label",
  "note": "_4xZM7q_note",
  "row": "_4xZM7q_row",
  "rowIndex": "_4xZM7q_rowIndex",
  "rowLabel": "_4xZM7q_rowLabel",
  "section": "_4xZM7q_section",
  "table": "_4xZM7q_table",
  "title": "_4xZM7q_title",
});
